// extracted by mini-css-extract-plugin
export default {"alignIcon":"CollectionPointsTableHeaderCell_alignIcon__HjOWQ","text":"CollectionPointsTableHeaderCell_text__YkMzz","icon":"CollectionPointsTableHeaderCell_icon__LGbgi"};